export const FETCH_INITIAL_USER_SUCCESS: "FETCH_INITIAL_USER_SUCCESS" =
  "FETCH_INITIAL_USER_SUCCESS";
export type FetchInitialUserSuccessAction = {
  type: typeof FETCH_INITIAL_USER_SUCCESS;
};
export const fetchInitialUserSuccessActionCreator =
  (): FetchInitialUserSuccessAction => ({
    type: FETCH_INITIAL_USER_SUCCESS,
  });
